import { FreightService } from '@prisma/client';
import { useMemo } from 'react';

import { getRequestFormLabels, RequestFormLabels } from '../../utils/requestFormLabels';

export const useRequestFormLabels = (freightService: FreightService | undefined): RequestFormLabels =>
  useMemo(() => getRequestFormLabels(freightService), [freightService]);
